import React, { Fragment, useCallback, useState } from 'react';
import BootstrapAccordion from 'react-bootstrap/Accordion';
import { FormBlock, PlaceHolderInject } from '../../types/general';
import * as Schema from '../../types/schema';
import { DefaultBlockWrapper, PropsDriller } from './Form';
import Row from './Row';

function Accordion(props: FormBlock<Schema.Row>) {
	const { schema, options = {} } = props;
	const { BlockWrapper = DefaultBlockWrapper } = options;
	const [placeHolder, setPlaceHolder] = useState<PlaceHolderInject>();
	const id = schema.id;
	// @deprecated: schema.defaultActiveItemId;
	const defaultActiveItemId = (schema.accordionItems || []).filter((a) => a.active).map((a) => a.id);
	const drill = PropsDriller(props);

	const onPlaceHolder = useCallback((args: PlaceHolderInject) => {
		setPlaceHolder(args);
	}, []);

	const accordionItems = (schema.accordionItems || []).filter((item) => !item.hidden);
	return (
		<BlockWrapper id={id} type='accordion' schema={schema} onPlaceHolder={onPlaceHolder}>
			<BootstrapAccordion
				id={'accordion-' + id}
				key={'accordion-' + id}
				defaultActiveKey={defaultActiveItemId}
				alwaysOpen
				// style={rowStyle}
				className='mb-3'
			>
				{accordionItems
					? accordionItems.map((item) => {
							return (
								<BootstrapAccordion.Item key={item.id} eventKey={item.id}>
									<BootstrapAccordion.Header>{item.title}</BootstrapAccordion.Header>
									<BootstrapAccordion.Body>
										{!item.rows || (item.rows.length === 0 && placeHolder && placeHolder.element)}
										{item.rows
											? item.rows.map((row) => {
													return (
														<Fragment key={row.id}>
															{placeHolder &&
																placeHolder.before === row.id &&
																placeHolder.element}
															<Row schema={row} {...drill} />
															{placeHolder &&
																placeHolder.after === row.id &&
																placeHolder.element}
														</Fragment>
													);
											  })
											: null}
									</BootstrapAccordion.Body>
								</BootstrapAccordion.Item>
							);
					  })
					: null}
			</BootstrapAccordion>
		</BlockWrapper>
	);
}

export default Accordion;
